interface IStockDividendSummaryProps {
  sharePaid: number | null;
}

export default function StockDividendSummary({ sharePaid }: IStockDividendSummaryProps) {
  return (
    <div className="flex items-center">
      <div className="font-aeonik">
        <div className="flex flex-col rounded-xl bg-slate-100 p-3">
          <div className="m-0 text-lg tracking-wider text-slate-800">
            <strong className="font-bold">{sharePaid || "-"} Shares Paid</strong>
          </div>
          <span className="text-sm font-medium text-slate-500">Last Stock Dividend</span>
        </div>
      </div>
    </div>
  );
}
